import { CompendiumText } from "../CompendiumText";
import type { SceneSpoiler } from "@/data/schema/scene";
import { chapterNumber } from "@/lib/timeline/book/ChapterId";
import { SpoilerSection } from "../SpoilerSection";

interface TimelineSceneSpoilersProps {
  spoilers: readonly SceneSpoiler[];
  /** Whether it starts open. */
  spoilersOn: boolean;
  bookId: string | undefined;
  onToggle?: (open: boolean) => void;
}

export function TimelineSceneSpoilers({
  spoilers,
  spoilersOn,
  bookId,
  onToggle,
}: TimelineSceneSpoilersProps) {
  return (
    <SpoilerSection startOpen={spoilersOn} onToggle={onToggle}>
      {spoilers.map((spoiler) => (
        <div key={spoiler.details} className="timeline-scene-spoilers__item">
          <p>
            <CompendiumText text={spoiler.details} bookId={bookId} newTab />
          </p>
          <p className="timeline-scene-spoilers__from">
            Revealed in Chapter {chapterNumber(spoiler.revealedInChapterId)}
          </p>
        </div>
      ))}
    </SpoilerSection>
  );
}
